<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<path d="M177.07,39.7,160.3,22.93a10,10,0,0,0-14.13,0L100,69.09,53.83,22.93a10,10,0,0,0-14.13,0L22.93,39.7a10,10,0,0,0,0,14.13L69.09,100,22.93,146.17a10,10,0,0,0,0,14.13L39.7,177.07a10,10,0,0,0,14.13,0L100,130.91l46.17,46.16a10,10,0,0,0,14.13,0l16.77-16.77a10,10,0,0,0,0-14.13L130.91,100l46.16-46.17A10,10,0,0,0,177.07,39.7Z"/>
	</svg>
</template>

<script>
export default {
	name: "Times"
}
</script>
